import React, { useEffect, useState } from 'react';
import { getSeasonsByTeam, createSeason, deleteSeason } from '../api/seasons';
import { useCurrentTeam } from '../hooks/useCurrentTeam';
import Breadcrumb from '../components/Breadcrumb';
import './SeasonManager.css';

export default function SeasonManager() {
    const { team } = useCurrentTeam();
    const [seasons, setSeasons]   = useState([]);
    const [newName, setNewName]   = useState('');
    const [loading, setLoading]   = useState(true);
    const [error, setError]       = useState(null);

    useEffect(() => {
        if (!team?.id) return;
        setLoading(true);
        getSeasonsByTeam(team.id)
            .then(setSeasons)
            .catch(() => setError('Error cargando temporadas'))
            .finally(() => setLoading(false));
    }, [team?.id]);

    const handleCreate = async (e) => {
        e.preventDefault();
        if (!newName.trim()) return;
        try {
            const created = await createSeason(team.id, newName.trim());
            setSeasons(prev => [created, ...prev]);
            setNewName('');
        } catch (e) {
            setError('No se pudo crear la temporada. Comprueba que no exista ya.');
        }
    };

    const handleDelete = async (seasonId) => {
        if (!window.confirm('¿Eliminar esta temporada? Las jornadas perderán su asignación.')) return;
        try {
            await deleteSeason(seasonId);
            setSeasons(prev => prev.filter(s => s.id !== seasonId));
        } catch (e) {
            setError('No se pudo eliminar la temporada.');
        }
    };

    return (
        <div className="season-manager-wrapper">
            <Breadcrumb dark={false} crumbs={[
                { label: 'Inicio', to: '/dashboard' },
                { label: 'Temporadas' },
            ]} />
            <div className="season-card">
                <div className="season-header">
                    <i className="fa fa-calendar"></i>
                    <h1>Gestión de Temporadas</h1>
                    <p>Crea las temporadas del equipo para organizar las jornadas por fases.</p>
                </div>

                {error && (
                    <div className="season-error">
                        <i className="fa fa-exclamation-circle"></i> {error}
                    </div>
                )}

                <form className="season-form" onSubmit={handleCreate}>
                    <input
                        type="text"
                        className="season-input"
                        placeholder="Ej: 25/26"
                        value={newName}
                        onChange={e => setNewName(e.target.value)}
                        maxLength={10}
                        required
                    />
                    <button type="submit" className="btn-add-season">
                        <i className="fa fa-plus"></i> Añadir
                    </button>
                </form>

                {loading ? (
                    <p className="season-loading">Cargando...</p>
                ) : seasons.length === 0 ? (
                    <p className="season-empty">No hay temporadas creadas aún.</p>
                ) : (
                    <ul className="season-list">
                        {seasons.map(s => (
                            <li key={s.id} className="season-item">
                                <span className="season-name">
                                    <i className="fa fa-trophy"></i> Temporada {s.name}
                                </span>
                                <button
                                    className="btn-delete-season"
                                    onClick={() => handleDelete(s.id)}
                                    title="Eliminar temporada"
                                >
                                    <i className="fa fa-trash"></i>
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}
